import { isGetOtherCityPharmaciesAction, IsTargetFromProductCardGetOtherCityPharmaciesAction } from '@actions';
import { Directive, HostListener, Input } from '@angular/core';
import { AppState } from '@appStates';
import { Store } from '@ngrx/store';

// этот пайп создан для отслеживания клика по ссылке <a [routerLink]>
// так как click евент не тригерится на ссылках <a>

// использовать этот пайп нужно на кнопках "в других городах"
// так как он диспатчен экешн для поиска по другим городам

@Directive({
  selector: '[othersClickCatcher]'
})
export class OthersClickCatcherDirective {

  @Input('fromCard') public fromCard: boolean = false;

  constructor(
    private readonly store: Store<AppState>
  ) { }

  @HostListener('click', ['$event']) public toOthersClickEvent(): void {
    this.store.dispatch(isGetOtherCityPharmaciesAction({ other: true }));
    if (this.fromCard) {
      this.store.dispatch(IsTargetFromProductCardGetOtherCityPharmaciesAction({ other: true }));
    }
  }

}
